import { type FirebaseApp, getApps, initializeApp } from "firebase/app";
import { type Auth, getAuth } from "firebase/auth";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

for (const [key, value] of Object.entries(config)) {
  if (!value) {
    throw new Error(`VITE_FIREBASE_${key.replace(/([A-Z])/g, "_$1").toUpperCase()} is not set`);
  }
}

// HMR-safe: reuse the already-initialised app on Vite hot reloads.
export const firebaseApp: FirebaseApp = getApps()[0] ?? initializeApp(config);

export const firebaseAuth: Auth = getAuth(firebaseApp);
